import { render, staticRenderFns } from "./UppyFileUploader.vue?vue&type=template&id=540ede1b"
import script from "./UppyFileUploader.vue?vue&type=script&lang=js"
export * from "./UppyFileUploader.vue?vue&type=script&lang=js"
import style0 from "./UppyFileUploader.vue?vue&type=style&index=0&id=540ede1b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports